import { Table, type TableTdProps } from "@mantine/core";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
} & TableTdProps;

export function TableTd({ children, ...tableProps }: Props) {
  const defaultOption: Omit<TableTdProps, "children"> = {};
  const option = Object.assign({}, defaultOption, tableProps);
  return <Table.Td {...option}>{children}</Table.Td>;
}
